export const DefaultUseMethod = ["水煎煮", "内服", "温服", "饭后服"];